import { Config as FinalFormConfig } from 'final-form';
import omitBy from 'lodash/fp/omitBy';
import isNil from 'lodash/isNil';
import { FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import styled from 'styled-components';

import { TextField } from '../fields';
import { googleAnalytics4 } from '../validators';

type HOCs = FinalFormConfig;

type TrackingFormProps = {
  onChange: (value: any) => void;
  isPending?: boolean;
};

const Wrapper = styled.form`
  & > div:not(:last-child) {
    margin-bottom: 18px;
  }

  input {
    color: #292a2b;
    margin: 0;

    &::-webkit-input-placeholder {
      color: #919eaa;
    }
  }
`;

const renderForm = ({ onChange: handleChange }: TrackingFormProps) => ({
  handleSubmit,
  values
}: FormRenderProps) => {
  const handleBlur = (values: { [key: string]: string | undefined }) => {
    const cleanedValues = omitBy(isNil)(values);

    handleChange(cleanedValues);
  };

  return (
    <Wrapper onSubmit={handleSubmit} onBlur={() => handleBlur(values)}>
      <TextField
        name="googleTrackId"
        label="Your Google Analytics 4 measurement ID"
        placeholder="G-XXXXXXXXXX"
        inputVariant="simple-small"
        labelVariant="static-above"
        validate={googleAnalytics4}
      />
      <TextField
        name="facebookPixelTrackId"
        label="Your Facebook Pixel tracking ID"
        placeholder="000000000000000"
        inputVariant="simple-small"
        labelVariant="static-above"
      />
    </Wrapper>
  );
};

const TrackingForm: FC<HOCs & TrackingFormProps> = props => (
  <Form render={renderForm(props)} {...props} />
);

export default TrackingForm;
